/**
 * Presentation for InternshipStatus on the company's own screens. Mirrors
 * InternshipStatus in app/core/constants.py.
 */

export const INTERNSHIP_STATUS_TONES = {
  DRAFT: 'neutral',
  PENDING_APPROVAL: 'warning',
  PUBLISHED: 'success',
  REJECTED: 'danger',
  CLOSED: 'neutral',
  FILLED: 'success',
  ARCHIVED: 'neutral',
};

export const INTERNSHIP_STATUS_LABELS = {
  DRAFT: 'Draft',
  PENDING_APPROVAL: 'In review',
  PUBLISHED: 'Live',
  REJECTED: 'Rejected',
  CLOSED: 'Closed',
  FILLED: 'Filled',
  ARCHIVED: 'Archived',
};
